import axios from "axios";
import { useNavigate } from "react-router-dom";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export default function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${API_BASE_URL}/logout`, null, { withCredentials: true });
      alert("로그아웃 성공");
      localStorage.removeItem("token");
      navigate("/login");
    } catch (error) {
      console.error("로그아웃 오류:", error);
      alert("로그아웃 실패");
    }
  };

  return (
    <button onClick={handleLogout} className="logout">
      로그아웃
    </button>
  );
}
